import {JsonObject, JsonProperty} from "json2typescript";

import {JsonPropertyEmpty} from "../../utils/json-util";

@JsonObject("TagSearchInput")
export class TagSearchInput {
    @JsonProperty("mediaId", String, true)
    public mediaId?: string = JsonPropertyEmpty;

    @JsonProperty("label", String, true)
    public label?: string = JsonPropertyEmpty;

    @JsonProperty("slug", String, true)
    public slug?: string = JsonPropertyEmpty;
    public constructor(args?: Partial<TagSearchInput>) {
        Object.assign(this, args);
    }
}
